import { BaseSettingsClient, AppSettings } from "@core/types";
import { Config } from "../config";

type FortimeAppSettings = {
  app: AppSettings;
};

class SettingsClient extends BaseSettingsClient {
  async getSettings() {
    const { data: settings } = await this.instance.get<FortimeAppSettings>("/wp-json/parhato-api/v1/settings");

    return { ...Config, ...settings?.app };
  }
}

export default SettingsClient;
